
import { Options, Vue } from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { BaseRoadmapItem, BeadItems, BigItem, RoadMapData } from './data-model'
import BeadSVG from './svg/bead.vue'
import BigSVG from './svg/big.vue'
import SmallSVG from './svg/small.vue'
import BigeyeSVG from './svg/bigeye.vue'
import { getRoadMapScrolledData, parseRoadMap } from './utils'
import CockroachSVG from './svg/cockroach.vue'

type TableStayle = {
    width?: string
}

type TdStyle = {
    height?: string
    width?: string
}

type BeadStyle = {
    height?: string
    width?: string
    top?: string
    left?: string
}

type SvgData = {
    beads: BeadItems[]
    bigs: BigItem[]
    bigeyes: BaseRoadmapItem[]
    smalls: BaseRoadmapItem[]
    cockroaches: BaseRoadmapItem[]
}

@Options({
    components: {
        'bead': BeadSVG,
        'big-road': BigSVG,
        'small-road': SmallSVG,
        'big-eye': BigeyeSVG,
        'cockroach': CockroachSVG
    }
})
export default class SvgMap extends Vue {
    @Prop({ default: 0 }) display!: number
    @Prop({ required: true }) mapData!: string
    @Prop({ required: true }) gameType!: string
    @Prop({ default: 8 }) beadRowCount!: number
    @Prop({ default: false }) predictionEnabled!: boolean

    isFirstLoad = true

    $emit!: Vue['$emit']

    beadWidth: TableStayle = {
        width: '0px'
    }

    otherTableStyle = {
        width: '0px',
        top: '0px',
        left: '0px',
        position: 'absolute',
        height: '0px'
    }
    otherTdStyle: TdStyle = {
        width: '0px',
        height: '0px'
    }

    tdStyle: TdStyle = {
        width: '0px',
        height: '0px'
    }

    tdStyleD1: TdStyle = {
        width: '0px',
        height: '0px'
    }

    roadMapData!: RoadMapData
    nextRed!: RoadMapData
    nextBlue!: RoadMapData

    bigCols = 1
    bigEyeCols = 1
    smallCols = 1
    cockroachCols = 1

    predictionTimer: number | boolean = false
    predictionType = 0
    predictionCount = 9
    predictionBlink = 9

    tableKey = `table-key-${new Date().getTime()}`
    otherRow = 0
    beadRow = 0
    resizeTimeOut: boolean | number = false
    $refs!: Vue['refs']

    svgData: SvgData = {
        beads: [],
        bigs: [],
        bigeyes: [],
        smalls: [],
        cockroaches: []
    }

    beforeMount(): void {
        window.addEventListener('resize', this.handleResizeWindow)
    }

    mounted(): void {
        this.handleResizeWindow()
    }

    beforeUnmount(): void {
        window.removeEventListener('resize', this.handleResizeWindow)
    }

    handleResizeWindow(): void {
        if (typeof this.resizeTimeOut === 'number') {
            clearTimeout(this.resizeTimeOut)
            this.resizeTimeOut = false
        }

        this.resizeTimeOut = setTimeout(() => {
            this.calculateBaseWidth()
        }, 50)
    }

    calculateBaseWidth(): void {
        const el = this.$refs['bodyRef'] as HTMLElement

        if (typeof el === 'object') {
            const h = el.getBoundingClientRect().height
            const w = el.getBoundingClientRect().width
            if (this.display === 0) {
                const _ht = h / 6
                const _tdSize = _ht
                const _otherTdSize = _tdSize / 2
                this.beadRow =
                    Math.floor(
                        (w - _tdSize * this.beadRowCount) / _otherTdSize
                    ) + 1
                this.beadWidth = { width: `${_ht * this.beadRowCount}px` }
                this.tdStyle = { width: `${_tdSize}px`, height: `${_tdSize}px` }

                this.otherTableStyle = {
                    width: `${(this.beadRow * _tdSize) / 2}px`,
                    top: '0px',
                    left: `${_ht * this.beadRowCount}px`,
                    position: 'absolute',
                    height: `${h}px`
                }

                this.otherTdStyle = {
                    width: `${_tdSize / 2}px`,
                    height: `${_tdSize / 2}px`
                }
            } else if (this.display === 1) {
                // this.beadRow = Math.floor(w / 30)
                // this.otherRow = this.beadRow * 2
                // this.beadWidth = { width: `${this.beadRow * 30}px` }
                const _cw = h / 12
                this.beadRow = Math.floor(w / _cw) + 1
                this.beadWidth = { width: `${this.beadRow * _cw}px` }

                this.tdStyleD1 = {
                    width: `${_cw}px`,
                    height: `${_cw}px`
                }
            }
        }
    }

    getBeadStyle(item: BeadItems): BeadStyle {
        const el = this.$refs['bodyRef'] as HTMLElement
        if (typeof el === 'object') {
            const h = el.getBoundingClientRect().height
            const w = el.getBoundingClientRect().width
            const _ht = h / 6

            return {
                width: `${_ht}px`,
                height: `${_ht}px`,
                left: `${item.x * _ht}px`,
                top: `${item.y * _ht}px`
            }
        }
        return {}
    }

    getBigStyle(item: BigItem) {
        console.log('node')
        const el = this.$refs['bodyRef'] as HTMLElement
        if (typeof el === 'object' && this.display === 0) {
            const h = el.getBoundingClientRect().height
            const w = el.getBoundingClientRect().width
            const _ht = h / 12

            return {
                width: `${_ht}px`,
                height: `${_ht}px`,
                left: `${item.x * _ht}px`,
                top: `${item.y * _ht}px`,
                position: 'absolute'
            }
        } else if (typeof el === 'object' && this.display === 1) {
            const h = el.getBoundingClientRect().height
            const w = el.getBoundingClientRect().width
            const _ht = h / 12

            return {
                width: `${_ht}px`,
                height: `${_ht}px`,
                left: `${item.x * _ht}px`,
                top: `${item.y * _ht}px`,
                position: 'absolute'
            }
        }

        return {
            width: `0px`,
            height: `0px`,
            left: `0px`,
            top: `0px`,
            position: 'absolute',
            display: 'none'
        }
    }

    getSmallStyle(item: BaseRoadmapItem) {
        const el = this.$refs['bodyRef'] as HTMLElement
        if (typeof el === 'object' && this.display === 0) {
            const h = el.getBoundingClientRect().height
            const w = el.getBoundingClientRect().width
            const _ht = h / 24

            return {
                width: `${_ht}px`,
                height: `${_ht}px`,
                left: `${item.x * _ht}px`,
                top: `${item.y * _ht}px`,
                position: 'absolute'
            }
        }
        return {
            width: `0px`,
            height: `0px`,
            left: `0px`,
            top: `0px`,
            position: 'absolute',
            display: 'none'
        }
    }

    bigContentStyle() {
        const el = this.$refs['bodyRef'] as HTMLElement
        if (this.display === 0 && typeof el === 'object') {
            const h = el.getBoundingClientRect().height
            const _ht = h / 6

            const style = {
                position: 'absolute',
                top: '0px',
                left: `${_ht * this.beadRowCount}px`
            }

            return style
        } else if (this.display === 1 && typeof el === 'object') {
            return {
                position: 'absolute',
                top: '0px',
                left: `0px`
            }
        }

        return {
            width: `0px`,
            height: `0px`,
            left: `0px`,
            top: `0px`,
            position: 'absolute',
            display: 'none'
        }
    }

    smallContentStyle() {
        const el = this.$refs['bodyRef'] as HTMLElement
        if (this.display === 0 && typeof el === 'object') {
            const h = el.getBoundingClientRect().height
            const _ht = h / 6

            const style = {
                position: 'absolute',
                top: `${h * 0.75 - 3}px`,
                left: `${_ht * this.beadRowCount}px`,
                background: 'red'
            }

            return style
        }

        return {
            width: `0px`,
            height: `0px`,
            left: `0px`,
            top: `0px`,
            position: 'absolute',
            display: 'none'
        }
    }
    bigeyeContentStyle() {
        const el = this.$refs['bodyRef'] as HTMLElement
        if (this.display === 0 && typeof el === 'object') {
            const h = el.getBoundingClientRect().height
            const _ht = h / 6

            const style = {
                position: 'absolute',
                top: `${h * 0.5 - 3}px`,
                left: `${_ht * this.beadRowCount}px`,
                background: 'red'
            }

            return style
        }

        return {
            width: `0px`,
            height: `0px`,
            left: `0px`,
            top: `0px`,
            position: 'absolute',
            display: 'none'
        }
    }

    cockroachContentStyle() {
        const el = this.$refs['bodyRef'] as HTMLElement
        if (this.display === 0 && typeof el === 'object') {
            const h = el.getBoundingClientRect().height
            const _ht = h / 6

            const style = {
                position: 'absolute',
                top: `${h * 0.75 - 3}px`,
                left: `${_ht * this.beadRowCount +
                    (this.beadRow + 2) * (_ht / 4)}px`,
                background: 'red'
            }

            return style
        }

        return {
            width: `0px`,
            height: `0px`,
            left: `0px`,
            top: `0px`,
            position: 'absolute',
            display: 'none'
        }
    }

    parseScrollData(_data?: RoadMapData): void {
        if (!_data) {
            _data = this.roadMapData
        }

        const p = getRoadMapScrolledData({
            roadmapData: _data,
            beadCol: this.beadRowCount,
            bigCol: this.beadRow - 1,
            bigeyeCol: this.beadRow - 1,
            smallCol: this.beadRow - 1,
            cocRoachCol: this.beadRow - 1
        })

        this.svgData.beads = p.beads
        this.svgData.bigs = p.bigs
        this.svgData.bigeyes = p.bigeyes
        this.svgData.smalls = p.smalls
        this.svgData.cockroaches = p.cockRoaches
    }

    Predict(color: number) {
        if (!this.predictionEnabled || this.mapData === '') return

        this.predictionType = color
        this.predictionCount = this.predictionBlink

        if (typeof this.predictionTimer !== 'number') {
            this.predictionTimer = setInterval(() => {
                // pre
                if (this.predictionCount % 2 !== 0) {
                    if (this.predictionType === 1 && this.nextRed) {
                        this.parseScrollData(this.nextRed)
                    } else if (this.predictionType === 2 && this.nextBlue) {
                        this.parseScrollData(this.nextBlue)
                    }
                } else {
                    if (this.roadMapData) {
                        this.parseScrollData(this.roadMapData)
                    }
                }

                if (
                    this.predictionCount === 0 &&
                    typeof this.predictionTimer === 'number'
                ) {
                    clearInterval(this.predictionTimer)
                    this.predictionTimer = false
                }

                this.predictionCount--
            }, 200)
        }
    }

    @Watch('mapData', { immediate: true, deep: true })
    OnUpdateDate(value: string): void {
        this.roadMapData = parseRoadMap(value)

        this.nextRed = parseRoadMap(`${value}#1`)
        this.nextBlue = parseRoadMap(`${value}#2`)

        this.$emit(
            'road-map-data',
            this.roadMapData,
            this.nextRed,
            this.nextBlue
        )

        if (this.isFirstLoad) {
            this.isFirstLoad = false
            setTimeout(() => {
                this.parseScrollData()
            }, 100)
        } else {
            this.parseScrollData()
        }

        // if (this.readyToRender && typeof this.predictionTimer !== 'number')
        //     this.drapMap()
    }
}
